/**
 * @file
 * Coins toast with 3D spinning coins scene.
 */

import ToastCoins from './js/ToastCoins.js';

(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.coinsToast = {
    attach: function (context) {
      // Check if context itself is a coins toast
      let elements = [];
      if (context.matches && context.matches('.advanced-toast--coins')) {
        elements.push(context);
      }
      // Also find coins toasts within the context
      const foundElements = context.querySelectorAll('.advanced-toast--coins');
      elements = elements.concat(Array.from(foundElements));

      once('coins-3d-scene', elements).forEach(function (element) {
        const toastCoins = new ToastCoins(element);
        toastCoins.init();
      });
    }
  };

})(Drupal, once);

